import React from "react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import {
  LayoutDashboard,
  FileText,
  Bell,
  Settings,
  TrendingUp,
  Shield,
  Brain,
  User,
  Users,
  Rss,
  BarChart3,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

interface NavigationSidebarProps {
  activeView: string;
  onViewChange: (viewId: string) => void;
  archiveCount?: number | null;
}

export function NavigationSidebar({
  activeView,
  onViewChange,
  archiveCount,
}: NavigationSidebarProps) {
  const { user } = useAuth();
  const isAdmin = user?.role?.toLowerCase() === 'admin';

  // DEBUG: Force re-render v2
  console.log('🚀 NavigationSidebar rendered - timestamp:', new Date().toISOString());

  const navigationItems = [
    {
      icon: LayoutDashboard,
      label: "Dashboard",
      active: true,
      badge: null,
      id: "dashboard",
    },
    {
      icon: Brain,
      label: "AI Quality Control",
      active: false,
      badge: null,
      id: "ai-quality-control",
    },
    {
      icon: BarChart3,
      label: "CMS Market Analysis",
      active: false,
      badge: null,
      id: "cms-market-analysis",
    },
    {
      icon: FileText,
      label: "Archive",
      active: false,
      badge: archiveCount ?? null,
      id: "archive",
    },
    {
      icon: Settings,
      label: "User Settings",
      active: false,
      badge: null,
      id: "user-settings",
    },
    {
      icon: User,
      label: "Account Settings",
      active: false,
      badge: null,
      id: "account-settings",
    },
  ];

  // Add Admin Dashboard for admins only
  if (isAdmin) {
    navigationItems.splice(1, 0, {
      icon: Users,
      label: "Admin Dashboard",
      active: false,
      badge: null,
      id: "admin-dashboard",
    });
  }

  console.log('🔍 Navigation items:', navigationItems.map(item => item.label));

  return (
    <div className="w-64 bg-card border-r border-border h-full flex flex-col">
      {/* Navigation Items */}
      <nav className="flex-1 p-4">
        <div className="space-y-2">
          {navigationItems.map((item, index) => (
            <Button
              key={index}
              variant={
                activeView === item.id ? "default" : "ghost"
              }
              className={`w-full justify-start h-11 ${
                activeView === item.id
                  ? "bg-primary text-primary-foreground"
                  : "hover:bg-accent/10"
              }`}
              onClick={() => onViewChange(item.id)}
            >
              <item.icon className="w-4 h-4 mr-3" />
              <span className="flex-1 text-left">
                {item.label}
              </span>
              {item.badge && (
                <Badge
                  variant="secondary"
                  className="ml-auto bg-accent text-accent-foreground"
                >
                  {item.badge}
                </Badge>
              )}
            </Button>
          ))}
        </div>
      </nav>
    </div>
  );
}
